var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import { pdfjs } from 'react-pdf';
// pdfjs.GlobalWorkerOptions.workerSrc = './pdf.worker.min.js';
import { useEffect, useRef } from 'react';
import './App.css';
import Router from './routes/Router';
import styled from 'styled-components';
import { useAppSelector, useCheckToken } from './hooks/redux';
import Sidebar from './components/Sidebar/Sidebar';
import getSocket from './services/socket';
import getExternalSocket, { disconnectExternalSocket, reconnectExternalSocket } from './services/externalSocket';
import Header from './components/Header/Header';
import { useNavigate, useLocation } from 'react-router-dom';
import { AUTH_PATHS } from '@/routes/paths/authPaths';
import { ToastContainer } from 'react-toastify';
function App() {
    var isAuth = useAppSelector(function (state) { return state.authStich.token; });
    var checkToken = useCheckToken();
    var socket = getSocket();
    var navigate = useNavigate();
    var location = useLocation(); // Use useLocation to get the current route
    var previousRestaurantId = useRef(null);
    useEffect(function () {
        socket.on("connect", function () {
            console.log("Socket connected!");
        });
        socket.on("error", function (error) {
            console.log(error, "Socket connected!");
        });
    }, []);
    // Initialize external socket when authenticated
    useEffect(function () {
        var initializeExternalSocket = function () {
            if (checkToken || isAuth) {
                var token = localStorage.getItem('token');
                var restaurantId = localStorage.getItem('selectedRestaurantId') || localStorage.getItem('restaurantId');
                if (token && restaurantId) {
                    // Check if restaurantId changed
                    if (previousRestaurantId.current !== restaurantId) {
                        if (previousRestaurantId.current !== null) {
                            // Restaurant changed, reconnect
                            console.log('[App] Restaurant changed, reconnecting external socket...');
                            reconnectExternalSocket();
                        }
                        else {
                            // First connection
                            console.log('[App] Initializing external socket...');
                            try {
                                getExternalSocket();
                            }
                            catch (error) {
                                console.error('[App] Error initializing external socket:', error);
                            }
                        }
                        previousRestaurantId.current = restaurantId;
                    }
                    else {
                        // Same restaurant, just ensure connection
                        try {
                            getExternalSocket();
                        }
                        catch (error) {
                            console.error('[App] Error getting external socket:', error);
                        }
                    }
                }
            }
            else {
                // User logged out, disconnect external socket
                disconnectExternalSocket();
                previousRestaurantId.current = null;
            }
        };
        initializeExternalSocket();
        // Listen for storage changes (when restaurantId changes in another tab or component)
        var handleStorageChange = function (e) {
            if (e.key === 'selectedRestaurantId' || e.key === 'restaurantId') {
                var newRestaurantId = e.newValue;
                if (newRestaurantId && newRestaurantId !== previousRestaurantId.current) {
                    console.log('[App] RestaurantId changed in storage, reconnecting external socket...');
                    previousRestaurantId.current = newRestaurantId;
                    if (checkToken || isAuth) {
                        reconnectExternalSocket();
                    }
                }
            }
        };
        window.addEventListener('storage', handleStorageChange);
        // Cleanup on unmount
        return function () {
            window.removeEventListener('storage', handleStorageChange);
            // Don't disconnect on unmount, only on logout
            // disconnectExternalSocket();
        };
    }, [checkToken, isAuth]);
    useEffect(function () {
        // Check if the current route is `/store-redirect`
        if (location.pathname === '/store-redirect') {
            return; // Early return if the current route is /store-redirect
        }
        else if (!checkToken && !isAuth) {
            navigate(AUTH_PATHS.ROOT); // Redirect to login if not authenticated
        }
    }, [checkToken, isAuth, navigate, location.pathname]); // Ensure location.pathname is included
    return (_jsxs(Container, { children: [_jsx(ToastContainer, {}), checkToken || isAuth ? _jsx(Header, {}) : null, checkToken || isAuth ? _jsx(Sidebar, {}) : null, _jsx(Router, {})] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
export default App;
var templateObject_1;
